"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RemoveNotificationContainer = exports.RemoveFromCartNotification = exports.AddToCartNotification = exports.setLoggedInUser = exports.NotificationsType = exports.useNotifications = exports.NotificationsProvider = exports.NotificationContext = exports.CountryUrl = exports.Location = exports.LanguageDisplay = exports.CountryDisplay = exports.Country = exports.Language = exports.useApplication = exports.ApplicationProvider = exports.ApplicationContext = exports.getDisplayUom = void 0; // Component and Hooks

var Application_1 = __importStar(require("./Application"));

exports.ApplicationContext = Application_1.default;
Object.defineProperty(exports, "ApplicationProvider", {
  enumerable: true,
  get: function get() {
    return Application_1.ApplicationProvider;
  }
});
Object.defineProperty(exports, "useApplication", {
  enumerable: true,
  get: function get() {
    return Application_1.useApplication;
  }
});

var Notification_1 = __importStar(require("./Notification"));

exports.NotificationContext = Notification_1.default;
Object.defineProperty(exports, "NotificationsProvider", {
  enumerable: true,
  get: function get() {
    return Notification_1.NotificationsProvider;
  }
});
Object.defineProperty(exports, "useNotifications", {
  enumerable: true,
  get: function get() {
    return Notification_1.useNotifications;
  }
});

var Models_1 = require("./Models");

Object.defineProperty(exports, "Country", {
  enumerable: true,
  get: function get() {
    return Models_1.Country;
  }
});
Object.defineProperty(exports, "CountryDisplay", {
  enumerable: true,
  get: function get() {
    return Models_1.CountryDisplay;
  }
});
Object.defineProperty(exports, "CountryUrl", {
  enumerable: true,
  get: function get() {
    return Models_1.CountryUrl;
  }
});
Object.defineProperty(exports, "Language", {
  enumerable: true,
  get: function get() {
    return Models_1.Language;
  }
});
Object.defineProperty(exports, "LanguageDisplay", {
  enumerable: true,
  get: function get() {
    return Models_1.LanguageDisplay;
  }
});
Object.defineProperty(exports, "Location", {
  enumerable: true,
  get: function get() {
    return Models_1.Location;
  }
});

var HelperFunctions_1 = require("./Notification/HelperFunctions");

Object.defineProperty(exports, "getDisplayUom", {
  enumerable: true,
  get: function get() {
    return HelperFunctions_1.getDisplayUom;
  }
});

var Notification_2 = require("./Notification");

Object.defineProperty(exports, "NotificationsType", {
  enumerable: true,
  get: function get() {
    return Notification_2.NotificationsType;
  }
});

var Authentication_1 = require("./Authentication");

Object.defineProperty(exports, "setLoggedInUser", {
  enumerable: true,
  get: function get() {
    return Authentication_1.setLoggedInUser;
  }
});

var AddToCartNotification_1 = require("./Notification/AddToCartNotification");

Object.defineProperty(exports, "AddToCartNotification", {
  enumerable: true,
  get: function get() {
    return __importDefault(AddToCartNotification_1).default;
  }
});

var RemoveFromCartNotification_1 = require("./Notification/RemoveFromCartNotification");

Object.defineProperty(exports, "RemoveFromCartNotification", {
  enumerable: true,
  get: function get() {
    return RemoveFromCartNotification_1.RemoveFromCartNotification;
  }
});
Object.defineProperty(exports, "RemoveNotificationContainer", {
  enumerable: true,
  get: function get() {
    return RemoveFromCartNotification_1.RemoveNotificationContainer;
  }
});